module.exports = __webpack_public_path__ + "img/pole-green.356174c8.jpg";